import { Component, Input, EventEmitter, Output, OnInit, SimpleChange } from '@angular/core';
import { RestService } from 'src/app/services/rest.service';
import { PagerService } from 'src/app/services/pager.service';
import { AmToasterService } from '@angularminds/am-toaster';
import { GeneralService } from 'src/app/services/general.service';
@Component({
  selector: 'app-pagination-bar',
  templateUrl: './pagination-bar.component.html',
  styleUrls: ['./pagination-bar.component.scss'],
})
export class PaginationBarComponent implements OnInit {
  currentPage: number = 1;
  totalCount: number;
  listItems: any = [];
  totalRecordsPage: number;
  pager: any = {};

  constructor(
    private restService: RestService,
    private amToasterService: AmToasterService,
    private pagerService: PagerService,
    private generalService: GeneralService
  ) { }

  @Input() path: string;
  @Input() limitPerPage: number;
  @Input() entity: string;
  @Input() searchTerm: string;
  @Input() doNotLoad: boolean;
  @Input() currentType: string;
  @Input() absoluteUrl: boolean;
  @Output() data = new EventEmitter<any[]>();
  @Output() totalDataCount = new EventEmitter<number>();
  @Output() pagerData = new EventEmitter<any>();
  @Output() loading = new EventEmitter<boolean>();
  @Input() private reload: EventEmitter<boolean>;
  filterType
  // On init
  ngOnInit() {
    this.watchReloadFlag();
    this.generalService.filter$.subscribe(res => {
      this.filterType = res
    })
  }

  // reload will be emitted from parent component
  watchReloadFlag() {
    if (this.reload) {
      this.reload.subscribe(reload => {
        this.getData(this.currentPage);
      });
    }
  }

  // Get current page number from local storage
  getCurrentPage() {
    this.currentPage = !localStorage.getItem(`currentPage${this.entity}`)
      ? 1
      : Number(localStorage.getItem(`currentPage${this.entity}`));
  }

  // get the data from API
  hideLoading: boolean;
  getData(pageNo, term?: boolean) {
    if (!term) {
      this.loading.emit(true);
      this.hideLoading = true;
    }
    if (!this.currentType) {
      this.hideLoading = true;
      return this.loading.emit(true);

    }
    this.filterType = this.filterType || this.currentType
    localStorage.setItem(`currentPage${this.entity}`, pageNo);
    localStorage.setItem(`limitPerPage${this.entity}`, this.limitPerPage + '');
    this.currentPage = Number(pageNo);

    let url;
    if (this.currentType || this.currentType !== 'true') {
      url = `${this.path}?page=${this.currentPage}&limit=${this.limitPerPage}&term=${this.searchTerm}&filterType=${this.filterType}`
    } else {
      url = `${this.path}?page=${this.currentPage}&limit=${this.limitPerPage}&term=${this.searchTerm}`
    }


    this.restService
      .fetch(
        url,
        undefined,
        this.absoluteUrl,
      )
      .subscribe(
        response => {
          this.loading.emit(false);
          this.hideLoading = false;
          if (response) {
            this.totalCount = response.totalCount;
            this.totalDataCount.emit(this.totalCount);

            this.listItems = response.result;
            this.data.emit(this.listItems);
            this.totalRecordsPage = Math.ceil(response.totalCount / this.limitPerPage);
            this.setPagination(this.currentPage);
          } else {
            this.data.emit([]);
          }
        },
        error => {
          this.loading.emit(false);
          this.hideLoading = false;
          this.amToasterService.show('error', error, 'Error!');
        },
      );
  }

  // Set pagination data and pager data
  setPagination(pageNo) {
    if (this.limitPerPage * this.currentPage > this.totalCount) {
      localStorage.removeItem(`currentPage${this.entity}`);
      //   this.getCurrentPage();
      //   this.getData(this.currentPage);
    }
    pageNo = Number(pageNo);
    this.currentPage = pageNo;
    this.pager = this.pagerService.getPager(this.totalCount, pageNo, this.limitPerPage);
    this.pagerData.emit(this.pager);
  }

  // Set the record count
  setRecordCount(limit) {

    this.limitPerPage = limit;
    this.getData(this.currentPage);
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {

    const term = changes['searchTerm'] && changes['searchTerm'].currentValue;
    const limitPerPage = changes['limitPerPage'] && changes['limitPerPage'].currentValue;
    const entity = changes['entity'] && changes['entity'].currentValue;
    const type = changes['currentType'] && changes['currentType'].currentValue;

    const currentType = this.filterType;

    if (entity) {
      this.getCurrentPage();
      this.getData(this.currentPage);
    }
    if (term) {
      this.getData(this.currentPage, true);
    }
    if (!this.doNotLoad) {
      if (limitPerPage) {
        this.getCurrentPage();
        this.getData(this.currentPage);
      }
      if (type) {
        this.getData(this.currentPage);
      }
    }
    // if (limitPerPage) {
    //   
    //   

    //   this.getCurrentPage();
    //   this.getData(this.currentPage);
    // }
    // if (type) {
    //   
    //   

    //   this.getData(this.currentPage);
    // } // if (term) {
    //   
    //   this.getData(this.currentPage);
    // }
    // if (limitPerPage) {
    //   
    //   

    //   this.getCurrentPage();
    //   this.getData(this.currentPage);
    // }
  }
}
